document.addEventListener('DOMContentLoaded', () => {
  let nextPage = 2; // Start loading from the second page
  let isLoading = false;

  // Scroll-restore key, scoped to this collection URL.
  const STORAGE_KEY = 'collectionScroll:' + window.location.pathname;

  // Take scroll control away from the browser: on mobile the collection's
  // infinite-scrolled DOM is rebuilt from page 1 on a back-nav (bfcache miss),
  // so the browser's own restore lands at the top. We restore manually below.
  if ('scrollRestoration' in history) history.scrollRestoration = 'manual';

  // Fetch one page and append its products. Resolves with the number appended.
  const fetchPage = (pageNum) =>
    fetch(`${window.location.pathname}?view=load-more&page=${pageNum}`)
      .then((response) => response.text())
      .then((data) => {
        const parser = new DOMParser();
        const html = parser.parseFromString(data, 'text/html');
        const newProducts = html.querySelectorAll('.product-grid-image-container');
        const productGrid = document.querySelector('.product-grid');
        newProducts.forEach((product) => productGrid.appendChild(product));
        initializeImageLoading();
        return newProducts.length;
      });

  const loadMoreProducts = () => {
    if (isLoading) return; // Prevent duplicate requests
    isLoading = true;

    fetchPage(nextPage)
      .then((count) => {
        nextPage++;
        isLoading = false;
        // Stop further requests if no more products are loaded
        if (count === 0) window.removeEventListener('scroll', handleScroll);
      })
      .catch((error) => {
        console.error('Error loading more products:', error);
        isLoading = false;
      });
  };

  const handleScroll = () => {
    // Use `document.documentElement` for cross-browser compatibility
    const scrollPosition = window.scrollY + window.innerHeight;
    const threshold = document.documentElement.scrollHeight - 1000; // Adjust threshold as needed

    if (scrollPosition >= threshold) {
      loadMoreProducts();
    }
  };

  // Persist scroll position + how many pages were loaded so a back-nav can
  // rebuild the same view. pagehide fires reliably on mobile (unlike unload).
  window.addEventListener('pagehide', () => {
    try {
      sessionStorage.setItem(
        STORAGE_KEY,
        JSON.stringify({ y: window.scrollY || window.pageYOffset || 0, pages: nextPage })
      );
    } catch (e) {}
  });

  // True only when the user arrived here via back/forward (not a fresh click in).
  const isBackForward = () => {
    const nav = performance.getEntriesByType('navigation')[0];
    if (nav) return nav.type === 'back_forward';
    return performance.navigation && performance.navigation.type === 2;
  };

  // Sequentially reload the pages that were present before navigating away,
  // then jump back to the saved scroll position.
  const restoreScroll = () => {
    let saved;
    try {
      saved = JSON.parse(sessionStorage.getItem(STORAGE_KEY));
    } catch (e) {}
    if (!saved || !isBackForward()) return;
    sessionStorage.removeItem(STORAGE_KEY);

    const targetPages = saved.pages || 2; // exclusive bound = next page to load
    let page = 2;
    const loadNext = () => {
      if (page >= targetPages) {
        nextPage = targetPages;
        window.scrollTo(0, saved.y || 0);
        return;
      }
      fetchPage(page)
        .then(() => { page++; loadNext(); })
        .catch(() => { nextPage = page; window.scrollTo(0, saved.y || 0); });
    };
    loadNext();
  };

  // Fade the grid in on load, matching the index home-grid reveal (fadeInHome in
  // script-index-product.js). pre-load.liquid's critical CSS paints .product-grid
  // visibility:hidden and flips it visible on DOMContentLoaded; layer an opacity
  // fade on top so the collection eases in instead of snapping.
  (function fadeInGrid() {
    const grid = document.querySelector('.product-grid');
    if (!grid) return;
    grid.style.opacity = '0';
    grid.style.transition = 'opacity 0.9s ease-in-out';
    const imgs = Array.from(grid.querySelectorAll('.product-grid-image'));
    let done = false;
    const reveal = () => {
      if (done) return;
      done = true;
      requestAnimationFrame(() => { grid.style.opacity = '1'; });
      setTimeout(() => { grid.style.transition = ''; grid.style.opacity = ''; }, 950);
    };
    if (!imgs.length) { reveal(); return; }
    let loaded = 0;
    const tick = () => { if (++loaded >= imgs.length) reveal(); };
    imgs.forEach((img) => {
      if (img.complete && img.naturalWidth > 0) tick();
      else {
        img.addEventListener('load', tick, { once: true });
        img.addEventListener('error', tick, { once: true });
      }
    });
    // Safety: reveal even if some images never fire load/error.
    setTimeout(reveal, 1200);
  })();

  // Attach scroll event listener to the window
  window.addEventListener('scroll', handleScroll);

  // Attempt a back-nav restore on initial load. (A bfcache hit keeps the DOM and
  // scroll intact, so pageshow.persisted needs no work — performance navigation
  // type is 'back_forward' only on a real reload, which is what we handle here.)
  restoreScroll();
});
